import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { useContext, useState, useEffect } from 'react';
import PrivateRoute from './auth/privateRoute';
import Login from './login/index';
import Main from './main/index';
import Shifts from './shifts/shifts';
import LayoutMenu from './layout/index';
import Store from './store/index';
import News from './news';
import AdminPanel from './adminPanel';
import Profile from './profile';

function App() {
  return (
    <Router>
      <Store>
        <div style={{ visibility: 'hidden' }} id="recaptcha-container" />
        <Routes>
          <Route
            exact
            path="/"
            element={
              <PrivateRoute>
                <LayoutMenu>
                  <Main />
                </LayoutMenu>
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/admin"
            element={
              <PrivateRoute>
                <LayoutMenu>
                  <AdminPanel />
                </LayoutMenu>
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/shifts"
            element={
              <PrivateRoute>
                <LayoutMenu>
                  <Shifts />
                </LayoutMenu>
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/news"
            element={
              <PrivateRoute>
                <LayoutMenu>
                  <News />
                </LayoutMenu>
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/profile"
            element={
              <PrivateRoute>
                <LayoutMenu>
                  <Profile />
                </LayoutMenu>
              </PrivateRoute>
            }
          />
          <Route path="/login" element={<Login />} />
        </Routes>
      </Store>
    </Router>
  );
}

export default App;
